import { motion } from 'framer-motion';
import { Home, Landmark, Briefcase, Factory } from 'lucide-react';
import { Card, CardContent } from '../ui/card';

const loanTypes = [
  { icon: <Home className="w-6 h-6" />, name: 'Home Loans', description: 'Competitive rates for your dream home' },
  { icon: <Landmark className="w-6 h-6" />, name: 'Loan Against Property', description: 'Unlock the value of your assets' },
  { icon: <Briefcase className="w-6 h-6" />, name: 'Business Loans', description: 'Fuel your business growth' },
  { icon: <Factory className="w-6 h-6" />, name: 'Project Finance', description: 'Large-scale project funding' }
];

export const ServicesLoanTypes = () => (
  <section className="py-24 bg-[#0f172a]" data-testid="loan-types">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-center mb-16"
      >
        <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-white mb-4">
          Financing Options
        </h2>
        <p className="text-slate-400 max-w-2xl mx-auto">
          Diverse loan products to meet every financial requirement.
        </p>
      </motion.div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {loanTypes.map((loan, index) => (
          <motion.div
            key={loan.name}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
          >
            <Card className="h-full bg-white/5 border-white/10 hover:bg-white/10 transition-colors">
              <CardContent className="p-6 text-center">
                <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-[#3b5998] to-[#00bcd4] flex items-center justify-center text-white mx-auto mb-4">
                  {loan.icon}
                </div>
                <h3 className="font-heading text-lg font-semibold text-white mb-2">{loan.name}</h3>
                <p className="text-slate-400 text-sm">{loan.description}</p>
              </CardContent>
            </Card>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
